import React from "react";
import { Table, Tag, Space } from "antd";
import { FiCheckCircle } from "react-icons/fi";

export default function MisconfigurationsTab() {
	const [misconfigs] = React.useState([]);

	const columns = [
		{
			title: "Asset Name",
			dataIndex: "assetName",
			key: "assetName",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Issue",
			dataIndex: "issue",
			key: "issue",
			width: 200,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Severity",
			dataIndex: "severity",
			key: "severity",
			width: 100,
			render: (severity) => (
				<Tag
					color={severity === "High" ? "red" : "orange"}
					className="border-0"
					style={{ color: "#fff" }}
				>
					{severity}
				</Tag>
			),
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			width: 100,
			render: (status) => (
				<Tag
					color={status === "Fixed" ? "green" : "orange"}
					className="border-0"
					style={{ color: "#fff" }}
				>
					{status}
				</Tag>
			),
		},
		{
			title: "Action",
			key: "action",
			width: 100,
			render: (_, record) => (
				<Space size="small">
					<button
						type="button"
						className="btn btn-sm btn-primary fw-bold"
					>
						Fix
					</button>
				</Space>
			),
		},
	];

	return (
		<>
			{misconfigs.length === 0 ? (
				<div>
					<div className="card mt-5">
						<div className="card-body">
							<div className="d-flex flex-column align-items-center justify-content-center py-5">
								<FiCheckCircle size={48} className="text-success mb-3" />
								<h4 className="fw-bold text-gray-800 mb-2">All Systems Properly Configured</h4>
								<p className="text-gray-600 mb-4">No misconfigurations detected across your assets.</p>
							</div>

							<div className="mb-3">
								<div className="row g-2">
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div className="card h-lg-100">
											<div className="card-body d-flex flex-column py-4 px-6">
												<div className="fw-semibold fs-6 text-gray-500 mb-3">Checked Assets</div>
												<div className="d-flex justify-content-between align-items-center">
													<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">61</span>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div className="card h-lg-100">
											<div className="card-body d-flex flex-column py-4 px-6">
												<div className="fw-semibold fs-6 text-gray-500 mb-3">Compliant</div>
												<div className="d-flex justify-content-between align-items-center">
													<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">61</span>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div className="card h-lg-100">
											<div className="card-body d-flex flex-column py-4 px-6">
												<div className="fw-semibold fs-6 text-gray-500 mb-3">Compliance Rate</div>
												<div className="d-flex justify-content-between align-items-center">
													<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">100%</span>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-12">
										<div className="card h-lg-100">
											<div className="card-body d-flex flex-column py-4 px-6">
												<div className="fw-semibold fs-6 text-gray-500 mb-3">Last Checked</div>
												<div className="d-flex justify-content-between align-items-center">
													<span className="fw-semibold fs-3x text-gray-800 lh-1 ls-n2">Today</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className="card mt-5">
					<div className="card-body">
						<Table
							columns={columns}
							dataSource={misconfigs}
							rowKey="id"
							className="table antd-override mb-0"
							pagination={{
								pageSize: 10,
								className: 'mb-0',
								showTotal: (total, range) => (
									<span>
										{range[0]} to {range[1]} of {total} misconfigurations
									</span>
								),
							}}
						/>
					</div>
				</div>
			)}
		</>
	);
}
